/**
 * Sichtbare ARKO-Sprache (Lauf 2).
 * Webhook-Prefixes und interne Keys bleiben im Versand. Nur die Anzeige wird Alltagssprache.
 * §-9-RAO-Zeilen bleiben wortgleich.
 */

/** Gleiche Richtung wie die Suche (nichts gefunden, anders versuchen). Eigener Satz, Suche-Copy unangetastet. */
export const ARKO_NOTHING_FOUND_SENTENCE =
  'Nichts Passendes gefunden. Bitte anders versuchen — anderes Stichwort oder einen konkreten Paragraphen mit Gesetz (z. B. § 16 MRG).';

const RAO_KEEP_RE = /§\s*9\s*RAO/i;

const LEXCORE_MISS_BLOCK_RE =
  /Zu Ihrer Frage konnte LEXCORE[\s\S]*?(?:Prüfstempel|Pruefstempel)\./i;

const THRESHOLD_CLAUSE_RE = /keine Norm oberhalb der Trefferschwelle[^.]*/gi;

const SCHWELLE_SENTENCE_RE = /Kein Treffer oberhalb der Schwelle[^.]*\./gi;

const LEAKED_USER_PREFIX_RE =
  /^Rechtsfrage \(verifizierte Normen aus (?:LEXCORE|dem Normenbestand)\):\s*/i;

function softenArkoLine(line: string): string {
  let t = line;
  if (LEXCORE_MISS_BLOCK_RE.test(t)) {
    t = t.replace(LEXCORE_MISS_BLOCK_RE, ARKO_NOTHING_FOUND_SENTENCE);
  }
  t = t.replace(THRESHOLD_CLAUSE_RE, 'nichts Passendes gefunden');
  t = t.replace(SCHWELLE_SENTENCE_RE, ARKO_NOTHING_FOUND_SENTENCE);
  t = t.replace(/\bLEXCORE-Normpaket\b/g, 'Normenpaket');
  t = t.replace(/\bLEXCORE-Paket\b/g, 'Normenpaket');
  t = t.replace(/\bLEXCORE-Snapshot\b/gi, 'Normenbestand');
  t = t.replace(/\bLEXCORE-Quelle\b/gi, 'belegte Quelle');
  t = t.replace(/\baus LEXCORE\b/gi, 'aus dem Normenbestand');
  t = t.replace(/\bvon LEXCORE\b/gi, 'im Normenbestand');
  t = t.replace(/\büber LEXCORE\b/gi, 'im Normenbestand');
  t = t.replace(/\blexcore[_\s-]*miss\b/gi, 'nichts gefunden');
  t = t.replace(/\bLEXCORE\b/g, 'Normenbestand');
  return t.replace(/[ \t]{2,}/g, ' ');
}

/** Anzeige-Text. Zeilen mit § 9 RAO bleiben unverändert. */
export function softenArkoVisibleCopy(text: string): string {
  const raw = String(text ?? '');
  if (!raw) return raw;
  return raw
    .split('\n')
    .map((line) => (RAO_KEEP_RE.test(line) ? line : softenArkoLine(line)))
    .join('\n');
}

/** User-Blase: interner Rechtsfrage-Prefix nicht zeigen. Gespeicherter Versandtext bleibt. */
export function displayArkoTurnText(role: 'user' | 'bot', text: string): string {
  let t = String(text ?? '');
  if (role === 'user') {
    t = t.replace(LEAKED_USER_PREFIX_RE, '');
    t = t.replace(/^Aus meinem Gedächtnis:\s*/i, 'Notizblock: ');
  }
  return softenArkoVisibleCopy(t);
}
